import { IconVariants } from '@shared/components/Icon/IconMapper.ts';
import { getIconSrc } from '@shared/components/Icon/iconSets/getIconSrc.ts';
import { useUserDetails } from '@shared/providers/UserDetailsProvider/useUserDetails.tsx';

import styles from './Icon.module.scss';

interface IconProps {
  stylesClassName?: 'accordionIcon' | 'emptyStateIcon' | 'highlightsIcon';
  iconAltText: string;
  variant: IconVariants;
}

export function Icon({ variant, stylesClassName, iconAltText }: IconProps) {
  const { countryCode } = useUserDetails();

  return <img src={getIconSrc(variant, countryCode)} className={styles[stylesClassName || '']} alt={iconAltText} />;
}
